var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-events-buttons"},_vm._l((_vm.buttons),function(button){return _c('button',{staticClass:"t-events-buttons__item",class:{
      _active: _vm.view === button.name
    },on:{"click":function () { return _vm.handleChangeViewClick(button.name); }}},[_c(button.icon,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"t-events-buttons__text"},[_vm._v(_vm._s(button.title))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/pages/events/components/view-buttons/view-buttons.vue?vue&type=template&id=1b507909&
// module id = 925
// module chunks = 0